export default {
    methods: {
        addCall(call) {
            this.selectedCalls.push(call.callId);
        },
        removeCall(call) {
            this.selectedCalls.splice(this.selectedCalls.indexOf(call.callId), 1);
        },
        selectAll() {
            this.selectedCalls = this.selectedCalls.concat(this.unselectedCalls);
        },
        unselectAll() {
            this.selectedCalls = [];
        }
    },
    computed: {
        unselectedCalls() {
            const vm = this;
            return vm.value.filter(call =>
                vm.selectedCalls.indexOf(call.callId) === -1
            ).map(call => call.callId);
        }
    },
    data() {
        return {
            selectedCalls: []
        };
    }
};
